import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { Text } from '@myrealtrip/web-ui';

const NotFoundResult = () => {
  const theme = useTheme();

  return (
    <NotFoundMessage>
      <Text typography="headlineBold15" color={theme.colors.gray.s900}>
        일치하는 검색어가 없습니다.
      </Text>
      <Text typography="paragraphNormal13" color={theme.colors.gray.s600}>
        다른 검색어로 검색해보세요.
      </Text>
    </NotFoundMessage>
  );
};

const NotFoundMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 240px;
  > *:not(:last-of-type) {
    margin-bottom: 6px;
  }
`;

export default NotFoundResult;
